module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/main-visual_american-village-574edaa25c204b844eec0f4673f36611.jpg";